import { fetchUserInfo } from 'App/api/userApi';
import { USER_ROLES } from 'App/domain/user';

const rolePriority = [
  USER_ROLES.ADMIN,
  USER_ROLES.DEPLOYER,
  USER_ROLES.OPERATOR,
  USER_ROLES.MONITOR,
  USER_ROLES.BILLING,
  USER_ROLES.AGENT,
];

const compareRoles = (role1, role2) => {
  if (rolePriority.indexOf(role1.role) < rolePriority.indexOf(role2.role)) {
    return 1;
  } else if (rolePriority.indexOf(role1.role) > rolePriority.indexOf(role2.role)) {
    return -1;
  }
  return 0;
};

export const fetchCookieUser = async () => {
  const user = await fetchUserInfo();
  return {
    userId: user.userId,
    name: user.userName,
    email: '',
    organizationId: user.roles[0]?.organizationShortName,
    roles: user.roles
      .map(role => ({
        role: role.role,
        userId: user.userId,
        organizationId: role.organizationShortName,
        organizationDetails: {
          name: role.organizationShortName,
          shortName: role.organizationShortName,
        },
      }))
      .reduce((acc, role) => {
        const existingRole = acc.find(r => r.organizationId === role.organizationId);
        if (existingRole) {
          if (compareRoles(existingRole, role) > 0) {
            return acc;
          } else if (compareRoles(existingRole, role) < 0) {
            existingRole.role = role.role;
            return acc;
          } else {
            return acc;
          }
        } else {
          acc.push(role);
          return acc;
        }
      }, []),
  };
};
